<template>
  <div>
    <div class="md-autocomplete-loading" v-if="isRefreshing">
      <md-progress-spinner :md-diameter="40" :md-stroke="4" md-mode="indeterminate" />
    </div>

    <div v-show="config.showFilter">
      <md-toolbar class="_dynamic__toolbar toolbar_css">
        <md-field class="_uiKitInput">
          <label>{{config.label}}</label>
          <md-autocomplete
            :key="'_input'"
            md-dense
            :disabled="recordData && (recordData.status === 'Closed_By_Workflow' || recordData.status === 'Closed_Unresolved' || recordData.status === 'Closed_Completed')"
            :value="filterValue"
            :md-options="field.options"
            @md-changed="onAssigneeChanged"
            @md-selected="onDynamicSelect"
            @md-opened="triggerResize"
            @md-closed="closeAutoComplete"
          >
            <label>{{ config.label }}</label>
            <template slot="md-autocomplete-item" slot-scope="{ item }">
              {{ 
                field.displayFieldOne
                ? (
                  field.displayFieldTwo
                  ? (item[field.displayFieldOne] + ' ' + item[field.displayFieldTwo])
                  : item[field.displayFieldOne]
                )
                : item.name
              }}
            </template>
          </md-autocomplete>

          <!-- ATLAS-1173: <Case><Assignee Indicator/Control> Changes -->
          <a v-if="!isChanged" class="link-autocomplete" :href="'#/users/' + selectedId">{{filterValue}}</a>

        </md-field>
      </md-toolbar>
    </div>
    <md-snackbar md-position="center" :md-active.sync="isSnackbarOpen" md-persistent>
      <span class="capitalized">{{ snackbarMsg }}</span>
    </md-snackbar>
  </div>
</template>
<script>
import { API, graphqlOperation } from "aws-amplify";
import * as queries_custom from "@/graphql/queries_custom";
import * as mutations from "@/graphql/mutations";
import autoCompleteMixin from '@/mixins/autoCompleteMixin';

export default {
  name: "crud-dynamic-Autocomplete",
  components: {},
  mixins: [autoCompleteMixin],
  props: {
    config: {
      type: Object,
      required: true,
    },
    reassignTasks: {
      type: [Object, Array],
      required: false,
    },
    form: {
      type: Object,
      required: true,
    },
    save: {
      type: Function,
      required: true,
    },
    formConfig: {
      type: Object,
      required: true
    },
    recordData: {
      type: Object,
    },
    field: {
      type: Object,
    },
  },
  data: () => ({
    isRefreshing: false,
    filterValue: "",
    snackbarMsg: "",
    isSnackbarOpen: false,
    options: [],
    optionValues: [],
    selectedId: '',
    isChanged: false,
    isMounted: false
  }),
  methods: {
    async getDynamicList() {
      this.config.columnFilterList = [];
      let params = { limit: 999 },
        operation;
      operation = graphqlOperation(
        queries_custom[this.config.filterListQueryId],
        params
      );
      const result = await API.graphql(operation);
      if (result.data.searchUsers) {
        result.data.searchUsers.items.forEach((item) => {
          let filterColumnItems = {
            id: item.id,
            value: item.given_name + " " + item.family_name,
          };
          this.optionValues.push(filterColumnItems);
          this.options.push(filterColumnItems.value);
        });
      }
    },
    async onDynamicSelect(option) {
      if(this.selectedId === option.id) {
        return
      }
      console.log(option);
      this.formConfig.pageMode = 'assignee';
      this.form[this.config.fieldToBeUpdate] = option? option.id : null;

      // TODO: add lastAssignDate to Task
      if (this.config.fieldToBeUpdate == 'caseUserId') {
        this.form.lastAssignDate = new Date().toISOString();
      }
      
      this.isChanged = true;
      
      setTimeout(function() { 
        if (this.config.fieldToBeUpdate == "caseUserId") {
          this.save();
        } else if (this.config.fieldToBeUpdate == "taskUserId") {
          this.updateRecord(this.form[this.config.fieldToBeUpdate]);
        }
        
        this.selectedId = this.form[this.config.fieldToBeUpdate];
        //for showing autocomplete hyperlink
        this.isChanged = false;
      }.bind(this), 3000)

      // this.isRefreshing = true;
      //   let error = null;
      //   await this.updateRecord(option.id).catch((err) => (error = err));
      //   if (error) {
      //       return this.showNotification(null, error);
      //   }
      //   this.showNotification(`${[this.config.fieldToBeUpdate]} updated!`);
    },
    async updateRecord(value) {
      if (value == "") value = null;
      let input = {
        id: this.recordData.id,
        [this.config.fieldToBeUpdate]: value,
        [this.config.updatedById]: this.$reduce(this, "$Session.userId"),
      };
      console.log("Mutation Input => ", input);
      const operation = graphqlOperation(
        mutations[this.config.updateMutationId],
        { input }
      );
      return API.graphql(operation);
    },
    /**
     * show notification messge
     * if error object provided found then show error notification
     * @param  {String} msg the notificaiton message
     * @param  {Object} error the error object
     * @return {void}
     */
    showNotification(msg, error) {
      console.log(msg);
      console.log(error);
      this.isRefreshing = false;

      if (msg) {
        this.snackbarMsg = msg;
        this.isSnackbarOpen = true;
        return;
      }
      this.filterValue = this.config.defaultSelectedValue;
      if (error && error.message) {
        this.snackbarMsg = error.message;
        this.isSnackbarOpen = true;
        return;
      }

      this.snackbarMsg = "Something went wrong - please try again!";
      this.isSnackbarOpen = true;
    },
    /**
     * Global fix on Autocomplete input type to refresh the vue-grid-layout on input change
     * Call this method on @md-opened
     */
    triggerResize() {
      window.setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      }, 300);
      // Dispatch resize event so that vue material autocomplete resizes itself
      window.setImmediate(() => {
        window.dispatchEvent(new Event("resize"));
      });
    },
    closeAutoComplete() {
      //this.isOpened = false;
    },
    onAssigneeChanged(searchTerm) {
      this.isChanged = true;
      this.onSearch(searchTerm);
      if(!searchTerm){
        let option = {
          id: null
        }
        this.onDynamicSelect(option)
      }
    }
  },
  watch: {
      'config.defaultSelectedValue': {
        immediate: true,
        handler: function() {
          console.log("currentItem Changed");
          this.filterValue = this.config.defaultSelectedValue;

          //for showing autocomplete hyperlink
          setTimeout(function() { 
            this.isChanged = false;
          }.bind(this), 100)
        },
      },
      /**
       * ATLAS-1173: <Case><Assignee Indicator/Control> Changes
       * Hide autocomplete hyperlink when Reassign Task Dialog opens
       */
      'reassignTasks.showRelatedDialog': {
        immediate: true,
        handler: function() {
          if (this.reassignTasks && this.reassignTasks.showRelatedDialog) {
            // this.isChanged = true;
          }
        }
      },
      'form.caseUserId': {
        immediate: true,
        handler: function() {
          //if selectedId for href yet to be updated by mounted() then set it
          if (this.form.caseUserId && !this.isMounted) {
            this.selectedId = this.form.caseUserId;
            this.isMounted = true;
          }
        }
      },
      'form.taskUserId': {
        immediate: true,
        handler: function() {
          //if selectedId for href yet to be updated by mounted() then set it
          if (this.form.taskUserId && !this.isMounted) {
            this.selectedId = this.form.taskUserId;
            this.isMounted = true;
          }
        }
      }
    },
  mounted() {
    this.selectedId = this.form[this.config.fieldToBeUpdate];
    this.filterValue = this.config.defaultSelectedValue;
    console.log("this.$route.params.id => ", this.$route.params.id);
  },
};
</script>

<style lang="scss" scoped>
.capitalized {
  text-transform: capitalize;
}
.link-autocomplete { 
  position: absolute;
  top: 8px;
  background-color: #fff;
  padding-right: 16px;
}
.md-toolbar-section-start {
  .md-toolbar {
    padding: 9px 0px 0px 10px !important;
    margin-left: 7px;
    background-color: transparent !important;
    box-shadow: none;
  } 
}
.toolbar_css{
  background-color: transparent !important;
  box-shadow: none !important;
}
// hide text link when text field has focus
.md-focused + .link-autocomplete {
  display: none !important;
}
</style>